<template>
  <span></span>
</template>

<script>
import ice from "../../../lib/ice";

export default {
  name: "vc-share-call-ice",
  props: {
    method: {
      type: String,
      default: ""
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    ice.callIce(this.method, this.params);
  }
};
</script>
